import React from "react";
import { Link } from "react-router-dom";
import "./HomePage.css"; // Custom CSS for styling
import QuizGenie from "../../assets/images/QuizGenie.png"
import { motion } from 'framer-motion';

const HomePage = () => {
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <div className="h-screen overflow-y-auto bg-gradient-to-r from-blue-500 to-indigo-700 text-white flex flex-col items-center  no-scrollbar">

            {/* Header */}
            <header className="w-full flex justify-between items-center p-6 bg-opacity-50 backdrop-blur-lg">
                <img src={QuizGenie} alt="QuizGenie Logo" className="h-12" style={{ borderRadius: 5 }} />
                <nav>
                    <ul className="flex space-x-6">
                        <li><button onClick={() => scrollToSection('features')} className="hover:underline">Features</button></li>
                        <li><button onClick={() => scrollToSection('usecases')} className="hover:underline">Use Cases</button></li>
                        <li><button onClick={() => scrollToSection('contact')} className="hover:underline">Contact</button></li>
                    </ul>
                </nav>
            </header>

            {/* Hero Section */}
            <section className="text-center px-6">
                <motion.h1 initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="text-5xl font-bold">
                    QuizGenie: AI-Powered Quiz Engine
                </motion.h1>
                <p className="mt-4 text-lg max-w-2xl mx-auto">
                    Empowering educators and students with AI-generated quizzes from content and files.
                </p>
                <motion.img src={QuizGenie} alt="AI-powered Quiz" className="mt-8 w-2/5 max-w-lg mx-auto" style={{ borderRadius: 20 }} initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5 }} />
                <motion.button whileHover={{ scale: 1.1 }} className="mt-6 bg-white text-blue-600 px-6 py-3 rounded-md font-bold shadow-lg">
                    <Link to="/login">
                        <button>Get Started</button>
                    </Link>

                </motion.button>
            </section>

            {/* Features Section */}
            <section id="features" className="mt-12 w-full max-w-4xl text-center px-10 md:px-0">
                <h2 className="text-3xl font-bold">Features</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
                    <motion.div whileHover={{ scale: 1.05 }} className="p-6 bg-white text-blue-600 rounded-lg shadow-md">
                        <h3 className="font-bold text-xl">AI-Generated Quizzes</h3>
                        <p>Automatically create quizzes from text and files.</p>
                    </motion.div>
                    <motion.div whileHover={{ scale: 1.05 }} className="p-6 bg-white text-blue-600 rounded-lg shadow-md">
                        <h3 className="font-bold text-xl">Customization</h3>
                        <p>Edit and modify quizzes as per your needs.</p>
                    </motion.div>
                    <motion.div whileHover={{ scale: 1.05 }} className="p-6 bg-white text-blue-600 rounded-lg shadow-md">
                        <h3 className="font-bold text-xl">Analytics</h3>
                        <p>Track student performance and progress.</p>
                    </motion.div>
                </div>
            </section>

            {/* Use Cases Section */}
            <section id="usecases" className="mt-20 w-full max-w-4xl text-center">
                <h2 className="text-3xl font-bold">Use Cases</h2>
                <p className="mt-4">QuizGenie is perfect for:</p>
                <ul className="mt-4 space-y-2">
                    <li>✅ Teachers creating assessments quickly</li>
                    <li>✅ Students testing their knowledge</li>
                    <li>✅ Corporate training and skill evaluation</li>
                </ul>
            </section>

            {/* Footer Section */}
            <footer id="contact" className="mt-20 bg-white text-blue-600 w-full p-6 text-center">
                <p>Contact us at <a href="mailto:abhishekpowade@gmail.com" className="underline">abhishekpowade@gmail.com</a></p>
                <p>&copy; 2025 QuizGenie. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default HomePage;
